import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

const Breadcrumb = ({ customItems = null }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Custom breadcrumb items (for job details, blog details, etc.)
  if (customItems) {
    return (
      <nav className="breadcrumb-nav" aria-label="Breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          {customItems.map((item, index) => (
            <li key={index} className={`breadcrumb-item ${index === customItems.length - 1 ? 'active' : ''}`}>
              {index === customItems.length - 1 ? (
                <span aria-current="page">{item.label}</span>
              ) : (
                <Link to={item.path}>{item.label}</Link>
              )}
            </li>
          ))}
        </ol>
        
        {/* Structured Data for Breadcrumbs */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.ak-consultants.in/"
              },
              ...customItems.map((item, index) => ({
                "@type": "ListItem",
                "position": index + 2,
                "name": item.label,
                "item": item.path ? `https://www.ak-consultants.in${item.path}` : undefined
              }))
            ]
          })}
        </script>
      </nav>
    );
  }

  // Auto-generated breadcrumbs for standard pages
  const breadcrumbNameMap = {
    about: 'About Us',
    services: 'Our Services',
    ourtech: 'Our Tech',
    teams: 'Our Team',
    careers: 'Careers',
    blogs: 'Blogs',
    contact: 'Contact Us',
    'geo-spatial': 'GIS & Geospatial Services'
  };

  if (pathnames.length === 0) return null; // Don't show on homepage

  return (
    <nav className="breadcrumb-nav" aria-label="Breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const displayName = breadcrumbNameMap[value] || value.charAt(0).toUpperCase() + value.slice(1);

          return (
            <li key={to} className={`breadcrumb-item ${isLast ? 'active' : ''}`}>
              {isLast ? (
                <span aria-current="page">{displayName}</span>
              ) : (
                <Link to={to}>{displayName}</Link>
              )}
            </li>
          );
        })}
      </ol>
      
      {/* Structured Data for Breadcrumbs */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.ak-consultants.in/"
            },
            ...pathnames.map((value, index) => {
              const to = `/${pathnames.slice(0, index + 1).join('/')}`;
              const displayName = breadcrumbNameMap[value] || value.charAt(0).toUpperCase() + value.slice(1);
              return {
                "@type": "ListItem",
                "position": index + 2,
                "name": displayName,
                "item": `https://www.ak-consultants.in${to}`
              };
            })
          ]
        })}
      </script>
    </nav>
  );
};

export default Breadcrumb;